// import * as THREE from 'three';
// import { gsap } from 'gsap';
import CustomProperty from "./Modules/CustomProperty.js";
// import * as Shader from "./Modules/Shader.js";
import * as Effect from "./Modules/Effect.js";
CustomProperty();


Effect.init();

// const canvas = document.getElementById('js-effect');
// const entryBtn = document.getElementById('js-entry');
// const overlay = document.getElementById('js-overlay');
// const title = document.getElementById('js-title');

// const width = window.innerWidth;
// const height = window.innerHeight;

// const scene = new THREE.Scene();

// const camera = new THREE.OrthographicCamera(
//   -width / 2,
//   width / 2,
//   height / 2,
//   -height / 2,
//   0.1,
//   10
// );
// camera.position.z = 1;

// const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
// renderer.setSize(width, height);
// renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// const uniforms = {
//   uTime: { value: 0 },
//   uProgress: { value: 0 },
//   uResolution: { value: new THREE.Vector2(width, height) },
// };


// const material = new THREE.ShaderMaterial({
//   vertexShader: Shader.vertex,
//   fragmentShader: Shader.fragment,
//   uniforms: uniforms,
//   transparent: true,
// });

// const geometry = new THREE.PlaneGeometry(width, height);
// const mesh = new THREE.Mesh(geometry, material);
// scene.add(mesh);

// let clock = new THREE.Clock(false);

// let animationId = null;

// function animate() {
//   animationId = requestAnimationFrame(animate);
//   uniforms.uTime.value = clock.getElapsedTime();
//   renderer.render(scene, camera);
// }

// animate();
// entryBtn.addEventListener('click', () => {
//   entryBtn.disabled = true;
//   clock.start();
//   const speed = 3 * window.innerHeight / window.innerWidth;
//   gsap.timeline()
//   .to(title, {
//     autoAlpha: 0,
//     duration: 0.5,
//   })
//   .to(uniforms.uProgress, {
//     value: 1,
//     duration: speed,
//     ease: 'power2.in',
//     onComplete: () => {
//       cancelAnimationFrame(animationId);
//       animationId = null;

//       renderer.domElement.style.display = 'none';
//       overlay.style.display = 'none';
//       document.documentElement.style.overflow = '';
//     }
//   }, "-=" + speed * 0.35);

//   animate();
// });

// window.addEventListener('resize', () => {
//   const w = window.innerWidth;
//   const h = window.innerHeight;

//   camera.left = -w / 2;
//   camera.right = w / 2;
//   camera.top = h / 2;
//   camera.bottom = -h / 2;
//   camera.updateProjectionMatrix();

//   renderer.setSize(w, h);
//   uniforms.uResolution.value.set(w, h);

//   mesh.geometry.dispose();
//   mesh.geometry = new THREE.PlaneGeometry(w, h);
// });
